// extracted by mini-css-extract-plugin
export default {"card":"D4-z"};